import _ from 'lodash';

import { resolve, resolveAll } from '../helpers/LinkMapper';

import IblocksAPIClient from '../lib/IblocksAPIClient';
import AuthenticatedAPIClient from '../lib/AuthenticatedAPIClient';
import UserStore from '../stores/UserStore';

import TransactionHistoryResults from '../records/customer/keygo/journeyHistory/TransactionHistoryResults';
import ReimbursementResponse from '../records/customer/keygo/reimbursement/ReimbursementResponse';
import Tap from '../records/customer/keygo/journeyHistory/Tap';
import Location from '../records/customer/keygo/completeJourney/Location';
import CollectionLocations from '../records/customer/keygo/CollectionLocation';
import { IBlocksCompleteJourneyError, IBlocksApiError } from '../errors/KeyGo';

export function getCustomerKeyGoUrl () {
    const user = UserStore.getCurrent();
    return `/smartcard/${user.id}/keygo`;
}

export function getCustomerSmartcardKeyGoUrl () {
    const user = UserStore.getCurrent();
    return `/customers/${user.id}/smartcard/keygo`;
}

export function trimMillis (datetime) {
    return `${datetime.toISOString().split('.')[0]}Z`;
}

const KeyGoService = {
    async getKeyGoTransactions (data = {}) {
        const url = getCustomerKeyGoUrl() + '/journey-history';
        const response = await IblocksAPIClient.get(url, data);
        return resolve(response).as(TransactionHistoryResults);
    },

    async completeJourney ({ journeyId, incompleteTap, reason, switchEntryExit }) {
        const url = getCustomerKeyGoUrl() + `/complete-journey/${journeyId}`;
        try {
            const completeJourneyResponse = await IblocksAPIClient.post(url, {
                locationCode: incompleteTap.locationCode,
                locationName: incompleteTap.locationName,
                timestamp: trimMillis(incompleteTap.timestamp),
                reasonCode: reason.title,
                reasonId: reason.id,
                switchEntryExit: switchEntryExit
            });
            return resolve(completeJourneyResponse).as(Tap);
        } catch (error) {
            if (error.body) {
                const status = error.body.status;
                const message = error.body.message;
                if (status === 409 || status === 400) {
                    throw new IBlocksCompleteJourneyError(message.code);
                } else {
                    throw new IBlocksApiError(message.message, message.code);
                }
            }
            throw error;
        }
    },

    async getCollectionLocations () {
        const response = await AuthenticatedAPIClient.get(`/delivery/collection-points/smartcard/keygo`);
        return resolveAll(response.result).as(CollectionLocations);
    },

    async getKeyGoLocations () {
        const url = getCustomerKeyGoUrl() + '/locations?filter=SUPPORTED_AREA';
        const response = await IblocksAPIClient.get(url);
        return resolveAll(response.locations).as(Location);
    },

    async withdrawKeyGoBalance () {
        const url = getCustomerSmartcardKeyGoUrl() + '/reimbursement';
        const response = await IblocksAPIClient.post(url);
        return resolve(response).as(ReimbursementResponse);
    },

    async withdrawKeyGoBalanceWithCheque (reimbursementId) {
        if (_.isUndefined(reimbursementId)) {
            return Promise.reject();
        } else {
            const url = `${getCustomerSmartcardKeyGoUrl()}/reimbursement/${reimbursementId}`;
            const response = await IblocksAPIClient.put(url);
            return resolve(response);
        }
    },

    async validateKeygo (collectionLocationNlc = null) {
        const user = UserStore.getCurrent();

        const data = {
            collectionLocationNlc,
        };

        const url = `/smartcard/${user.id}/validate-keygo`;
        try {
            await AuthenticatedAPIClient.post(url, data);
            return true;
        } catch (e) {
            console.warn('validateKeygo error', e);
            return false;
        }
    }

};

export default KeyGoService;
